<template>
  <div class="star-rating">
    <button
      v-for="star in 5"
      :key="star"
      type="button"
      :class="['star', { active: star <= displayValue, interactive: interactive }]"
      @click="interactive && handleClick(star)"
      @mouseenter="interactive && handleHover(star)"
      @mouseleave="interactive && handleLeave()"
      :aria-label="`${star} out of 5 stars`"
      :disabled="!interactive"
    >
      ★
    </button>
    <span v-if="showValue" class="rating-value">{{ modelValue }}/5</span>
  </div>
</template>

<script>
export default {
  name: 'StarRating',
  props: {
    modelValue: {
      type: Number,
      default: 0,
      validator: (value) => value >= 0 && value <= 5
    },
    interactive: {
      type: Boolean,
      default: false
    },
    showValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'change'],
  data() {
    return {
      hoverValue: 0
    }
  },
  methods: {
    handleClick(star) {
      this.$emit('update:modelValue', star)
      this.$emit('change', star)
    },
    handleHover(star) {
      this.hoverValue = star
    },
    handleLeave() {
      this.hoverValue = 0
    }
  },
  computed: {
    displayValue() {
      return this.hoverValue || this.modelValue
    },
    value() {
      return this.modelValue
    }
  },
  watch: {
    modelValue(newVal) {
      // Ensure value is within valid range
      if (newVal < 0) this.$emit('update:modelValue', 0)
      if (newVal > 5) this.$emit('update:modelValue', 5)
    }
  }
}
</script>

<style scoped>
.star-rating {
  display: flex;
  align-items: center;
  gap: 4px;
}

.star {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: var(--color-border-main);
  cursor: default;
  padding: 0;
  line-height: 1;
  transition: color var(--transition-normal);
  user-select: none;
}

.star.active {
  color: var(--color-warning-main);
}

.star.interactive {
  cursor: pointer;
}

.star.interactive:hover {
  color: var(--color-warning-dark);
  transform: scale(1.1);
}

.rating-value {
  margin-left: 8px;
  color: var(--color-text-secondary);
  font-size: 0.9rem;
  font-weight: 500;
}
</style>

